import { Injectable, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { SupportModel } from './supportModel';
import { TicketModel, CommentModel } from './support';

@Injectable({
  providedIn: 'root'
})
export class SupportApiService implements OnInit {

  apiEndpointSupport: string;

  constructor(private http: HttpClient) {
    this.apiEndpointSupport = environment.apiSupportEnpoint;
  }
  
  ngOnInit(): void {
    console.log("ngOnInit SupportApiService ")
  }

  async sendMessageToSupport(supportMessageModel: SupportModel): Promise<any> {
    return await this.http.post<any>(
      this.apiEndpointSupport, supportMessageModel
    ).toPromise();
  }

  async getMyTickets(): Promise<TicketModel[]> {
    const url = this.apiEndpointSupport.replace('/create', '/my-tickets');
    return await this.http.get<TicketModel[]>(url).toPromise();
  }

  async getTicketComments(issueKey: string): Promise<CommentModel[]> {
    const url = this.apiEndpointSupport.replace('/create', `/tickets/${issueKey}/comments`);
    return await this.http.get<CommentModel[]>(url).toPromise();
  }

}
